// import { useState } from "react";

// export const useDropdownPosition = () => {
//   const [position, setPosition] = useState({ top: 0, left: 0, width: 0 });

//   const calculatePosition = (ref) => {
//     if (ref?.current) {
//       const rect = ref.current.getBoundingClientRect();
//       setPosition({
//         top: rect.bottom + window.scrollY,
//         left: rect.left + window.scrollX,
//         width: rect.width,
//       });
//     }
//   };

//   return [position, calculatePosition];
// };

import { useState } from "react";

export const useDropdownPosition = () => {
  const [position, setPosition] = useState({
    top: 0,
    left: 0,
    width: 0,
    placement: "bottom",
  });

  const calculatePosition = (ref, dropdownHeight = 200) => {
    if (ref?.current) {
      const rect = ref.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const spaceBelow = viewportHeight - rect.bottom;
      const spaceAbove = rect.top;

      const shouldOpenAbove =
        spaceBelow < dropdownHeight && spaceAbove > dropdownHeight;

      setPosition({
        top: shouldOpenAbove
          ? rect.top + window.scrollY - dropdownHeight
          : rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        placement: shouldOpenAbove ? "top" : "bottom",
      });
    }
  };

  return [position, calculatePosition];
};
